import { render } from "./TheReviewsCard.vue?vue&type=template&id=0cd5fbdb&scoped=true"
import script from "./TheReviewsCard.vue?vue&type=script&lang=js"
export * from "./TheReviewsCard.vue?vue&type=script&lang=js"

import "./TheReviewsCard.vue?vue&type=style&index=0&id=0cd5fbdb&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Efren Bustos\\source\\repos\\VDAI\\vdai\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd5fbdb"]])

export default __exports__